/**
 * Creates a new object with the specified keys omitted from the original object.
 *
 * @param {Object} obj - The original object.
 * @param {string[]} keys - An array of keys to omit from the object.
 * @returns {Object} A new object with the specified keys omitted.
 *
 * @example
 * const obj = { foo: 1, bar: 2, baz: 3 };
 * const result = omit(obj, ['foo', 'baz']);
 * console.log(result); // { bar: 2 }
 */

export const omit = <T extends object, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> => {
  const result: Partial<T> = { ...obj }

  for (const key of keys) {
    if (key in result) {
      delete result[key]
    }
  }

  return result as Omit<T, K>
}
